import React from 'react';

const donationHeaderAbcGospel = ({ firstName = '' } = {}) => (
  <div>
    <h2
      style={{
        fontSize: '40px',
        textAlign: 'center',
        color: '#4a4a4a',
        fontFamily: 'proxima-nova, sans-serif',
      }}
    >
      Great News {firstName}! Your "Gospel Alphabet PDF" is on its way to your
      inbox.
    </h2>
    <br></br>
    <div>
      <p>
        Thank you for wanting to teach the younger generation about God’s Word.
        It’s our prayer that this resource will help the children you love be
        able to say,{' '}
        <em>
          “Your word I have hidden in my heart, that I might not sin against
          You”
        </em>{' '}
        (Psalm 119:11, NKJV).
      </p>
      <p>
        The Billy Graham Evangelistic Association is able to offer the hope of
        Jesus Christ through materials like this because of friends like you.
        The Lord is using the gifts and prayers of other believers to reach
        people across the globe with the Gospel—and there are so many more who
        need to hear the Good News of Jesus. If the Lord is leading you, you can
        be a part of this ministry by giving a secure donation today.
      </p>
      <a href="https://giving.billygraham.org/" className="button is-primary">
        <strong>Help Now</strong>
      </a>
    </div>
  </div>
);

export default donationHeaderAbcGospel;
